<template>
    <client-page class="dark-theme">
        <!-- S: 탭 -->
        <template #contentsImmersive>
            <v-container>
                <education-tabs />
            </v-container>
        </template>
        <!-- E: 탭 -->

        <!-- S: 서브 비주얼 -->
        <template #subHead>
            <sub-visual title="교육 · 법률지원" src="/images/sub/sub-visual-education.jpg"></sub-visual>
        </template>
        <!-- E: 서브 비주얼 -->

        <page-section class="page-section--sm page-section--first mb-n16px mb-md-n24px">
            <div v-for="youtubeLink, index in festa?.youtubeLink" :key="index" class="mb-16px mb-md-24px" data-aos="fade-up" data-aos-delay="100">
                <v-responsive :aspect-ratio="560/315">
                    <iframe width="100%" height="100%" :src="convertYouTubeURL(youtubeLink.title)" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                </v-responsive>
            </div>
        </page-section>

        <page-section title="교육 프로그램" class="page-section--sm page-section--last">
            <!-- 동영상 -->
            <u-tabs-solid v-model="tab" class="mb--md" data-aos="fade-up" data-aos-delay="100">
                <v-tab v-for="section, index in festa.section2" :key="index" @click="input(index)">{{ section?.name }}</v-tab>
            </u-tabs-solid>
            <v-tabs-items v-model="tab" data-aos="fade-up" data-aos-delay="200">
                <v-tab-item v-for="section, index in festa.section2" :key="index">
                    <page-section class="page-section--sm pt-0">
                        <template slot="pageSectionImmersive">
                            <table-primary>
                                <v-sheet v-for="(item, index) in section.items" :key="index">
                                    <v-row no-gutters align="center" class="font-size-16 font-size-md-24 font-weight-regular font-pretendard">
                                        <v-col cols="12" md="auto">
                                            <div class="px-12px pt-10px pl-md-0 pr-md-20px py-md-24px py-lg-40px w-md-160px">
                                                <div class="font-weight-extrabold grey--text text--darken-4">
                                                    <span v-html="item.title.replace(/\n/g, '<br />')" />
                                                </div>
                                            </div>
                                        </v-col>
                                        <v-col cols="12" md="">
                                            <div class="px-12px pt-4px pb-10px px-md-20px py-md-24px py-lg-40px">
                                                <div class="font-size-18 font-size-md-24">
                                                    <p v-html="item.txt.replace(/\n/g, '<br />')" />
                                                </div>
                                            </div>
                                        </v-col>
                                    </v-row>
                                    <v-divider />
                                </v-sheet>
                                <!-- <table-primary-row v-for="(item, index) in section.items" :key="index">
                                    <template #title>
                                        <span v-html="item.title.replace(/\n/g, '<br />')" />
                                    </template>
                                    <template #text>
                                        <p v-html="item.txt.replace(/\n/g, '<br />')" />
                                    </template>
                                </table-primary-row> -->
                            </table-primary>
                        </template>
                    </page-section>
                    <page-section class="page-section--sm pb-0">
                        <template slot="pageSectionImmersive">
                            <div class="tit-wrap">
                                <h3 class="tit">커리큘럼</h3>
                            </div>
                            <div class="mb--md">
                                <v-row v-for="curriculum, index in section.curriculums" :key="index" class="row--xs">
                                    <v-col cols="auto">
                                        <i class="dot mt-8px mt-md-6px primary"/>
                                    </v-col>
                                    <v-col>
                                        <h5 class="tit tit--xxs">
                                            {{curriculum?.title}}
                                        </h5>
                                        <ul v-for="subtitle, index in curriculum.subtitles" :key="index" class="mt-12px mt-md-24px">
                                            <li class="txt txt--dark">
                                                {{ subtitle.title }}
                                            </li>
                                            <ul class="mt-6px">
                                                <li v-for="item, index in subtitle.items" :key="index" class="txt mt-4px dot-txt">
                                                    · {{ item.title }}
                                                </li>
                                            </ul>
                                        </ul>
                                    </v-col>
                                </v-row>
                            </div>
                            <div v-for="link, index in section?.links" :key="index" class="mt-16px mt-md-24px">
                                <v-responsive :aspect-ratio="560/315">
                                    <iframe width="100%" height="100%" :src="convertYouTubeURL(link.title)" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen class="d-block"></iframe>
                                </v-responsive>
                            </div>
                            <v-layout justify-center class="mt--md">
                                <v-btn :href="section.link" target="_blank" x-large color="secondary" class="min-w-lg-180px justify-space-between">
                                    교육접수 바로가기
                                    <icon-arrow-rounded direction="right" class="icon--size-small ml-12px" />
                                </v-btn>
                            </v-layout>
                        </template>
                    </page-section>
                </v-tab-item>
            </v-tabs-items>
        </page-section>
    </client-page>
</template>

<script>
import api from "@/api";

import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";
import EducationTabs from "@/components/client/education/education-tabs.vue";
import PageSection from "@/components/dumb/page-section.vue";
import UTabsSolid from "@/components/dumb/u-tabs-solid.vue";
import TablePrimary from "@/components/dumb/table-primary.vue";
// import TablePrimaryRow from "@/components/dumb/table-primary-row.vue";
import IconArrowRounded from "@/components/client/icons/icon-arrow-rounded.vue";

export default {
    components: {
        ClientPage,
        SubVisual,
        EducationTabs,
        PageSection,
        TablePrimary,
        // TablePrimaryRow,
        UTabsSolid,
        IconArrowRounded,
    },
    props: {},
    data() {
        return {
            tab: 0,
            festa: null
        };
    },
    async mounted() {
        this.init();
    },
    methods: {
        async init() {
            let { festa } = await api.v1.education.festa.get();
            this.festa = festa;
        },
        input(index) {
            this.tab = index;
        },
        convertYouTubeURL(url) {
            const videoId = url.match(/(?:\?v=|\/embed\/|\.be\/|\/v\/|\/\d{1,2}\/|\/embed\/|\/e\/|\/watch\?v=|\/\d{1,2}\/|\/v\/|\/e\/|\/watch\?v=|\/\d{1,2}\/|\/v\/|\/e\/|\/watch\?v=)([^#\&\?\/\s]{11})/);
            if (videoId) {
                return `https://www.youtube.com/embed/${videoId[1]}`;
            }
            return null;
        },
    },
};
</script>

<style scoped>
.dot{
    width: 8px;
    height: 8px;
    border-radius: 50%;
    display: block;
}
.dot-txt{
    text-indent: -8px;
    padding-left: 8px;
}
@media (min-width:576px){
}
@media (min-width:768px){
    .dot{
        width: 12px;
        height: 12px;
    }
}
@media (min-width:1024px){
}
@media (min-width:1200px){
}

</style>
